import React, { useState } from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {auth} from '../firebase'
import {GoogleAuthProvider,signInWithPopup} from 'firebase/auth'
function Login() {
    const[email,setemail] = useState('');
    const[password,setpassword] = useState('');
    const history = useNavigate()
    const handleSubmit = async (e) =>{
        e.preventDefault()
        try{const result = await auth.signInWithEmailAndPassword(email,password)
        window.M.toast({html:`Welcome ${result.user.email}`,classes:'green'})
        history('/todo')}
        catch(err){
         window.M.toast({html:err.message,classes:'red'})}
        }
        const google = async () =>{
            const provider = new GoogleAuthProvider();
            try{const result = await signInWithPopup(auth,provider)
                window.M.toast({html:`Welcome ${result.user.email}`,classes:'green'})
                history('/todo')}
                catch(err){
                 window.M.toast({html:err.message,classes:'red'})}
                }
  return (
    <div className='center container'>
        <h1>Please Login</h1>
        <form onSubmit={e=>handleSubmit(e)}>
            <div className="input-field">
                <input type="email" name="email" value={email} onChange={e=>setemail(e.target.value)} placeholder='Enter your Email' />
                <input type="password" name="password" value={password} onChange={e=>setpassword(e.target.value)} placeholder='Enter your Password' />
            
            <Link to='/forgot' style={{float:'left'}}>forgot password?</Link>
            </div>
            <br />
                <button className='btn blue' type='submit' style={{marginTop:'1%'}}>Login</button>
        </form>
        <div>
             {/* <button className='btn blue' onClick={()=>google()} style={{marginTop:'1%'}}>Login with google</button> */}
    </div>
    </div>
  )
}

export default Login